"use strict";

exports.__esModule = true;
exports.ResourceType = exports.Resource = void 0;
var _StringUtils = require("../Utils/StringUtils");
var _XmlValidation2 = require("../Parsers/XmlValidation");
var _YoLog = require("../Utils/YoLog");
var _HttpConnection = require("../Utils/HttpConnection");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/**
 * Enumeration of possible Creative resource types:
 * @category Enumerations
 * @enum {number}
 */
var ResourceType = {
  /** Static resource e.g. jpeg, png */
  STATIC: 0,
  /** HTML resource */
  HTML: 1,
  /** Iframe resource */
  IFRAME: 2,
  /** Unknown resource: Used only to obtain Companions from the Advert that have tracking but no Resource. */
  UNKNOWN: 3
};

/**
 * Represents a resource object for a linear, non-linear or companion creative, or for an Industry Icon.
 *
 * Encapsulates the data from the `<Resource>` element of a VAST document.<br/>
 * It represents one of the following VAST resource types:
 * - StaticResource
 * - HTMLResource
 * - IFrameResource
 * 
 * @hideconstructor
 */
exports.ResourceType = ResourceType;
var Resource = /*#__PURE__*/function (_XmlValidation) {
  _inheritsLoose(Resource, _XmlValidation);
  function Resource(type, stringData, creativeType, encoded) {
    var _this;
    _this = _XmlValidation.call(this) || this;
    switch (type) {
      case ResourceType.STATIC:
        /** @private */
        _this.stringData = stringData;
        /** @private */
        _this.creativeType = creativeType;
        /** @private */
        _this.encoded = false;
        /** @private */
        _this.type = type;
        break;
      case ResourceType.IFRAME:
        /** @private */
        _this.stringData = stringData;
        /** @private */
        _this.creativeType = null;
        /** @private */
        _this.type = type;
        /** @private */
        _this.encoded = false;
        break;
      case ResourceType.HTML:
        /** @private */
        _this.stringData = stringData;
        /** @private */
        _this.creativeType = null;
        /** @private */
        _this.type = type;
        /** @private */
        _this.encoded = encoded;
        break;
    }

    /** @private */
    _this.byteData = null;
    return _this;
  }

  /**
   * Returns the byte data associated with this resource, if the type is StaticResource or IFrameResource,
   * or null if the type is HTMLResource.
   *
   * @return {number[]} a byte array representing the {@link Resource}, or null if it has not been loaded
   */
  var _proto = Resource.prototype;
  _proto.getByteData = function getByteData() {
    return this.byteData;
  }

  /**
   * @return {string} the value of creativeType - the MIME type of the static resource, or null if one wasn't provided in the VAST
   */;
  _proto.getCreativeType = function getCreativeType() {
    return this.creativeType;
  }

  /**
   * @return {ResourceType} the {@link ResourceType} of this resource
   */;
  _proto.getResourceType = function getResourceType() {
    return this.type;
  }

  /**
   * Returns the string data associated with this resource if the type is HTMLResource,
   * or the URL associated with this resource if the type is StaticResource or IFrameResource.
   *
   * @return {string} a string representing the resource, or the URL of the resource
   */;
  _proto.getStringData = function getStringData() {
    return this.stringData;
  }

  /**
   * Returns whether the string data for this resource is encoded. This method is only valid for
   * resources of type HTMLResource.
   * @return {boolean} true if the string data is encoded
   */;
  _proto.isEncoded = function isEncoded() {
    return this.encoded;
  };
  _proto.isValid = function isValid() {
    switch (this.type) {
      case ResourceType.STATIC:
        if (!this.creativeType || this.creativeType === "") {
          return false;
        }
        break;
      case ResourceType.HTML:
        if (!this.stringData || this.stringData === "") {
          return false;
        }
        break;
      case ResourceType.IFRAME:
        try {
          new URL(this.stringData);
        } catch (e) {
          return false;
        }
        break;
      default:
        return false;
    }
    return true;
  };
  _proto.prefetch = function prefetch(timeout) {
    var _this2 = this;
    if (this.byteData || this.type === ResourceType.HTML || this.type === ResourceType.UNKNOWN) {
      return;
    }
    _HttpConnection.HttpConnection.get(this.stringData, {}, timeout).then(function (response) {
      if (response.ok) {
        _this2.byteData = response.body;
      } else {
        _YoLog.YoLog.e("Resource prefetch request failed: " + _this2.stringData + ", status: " + response.status + ", error:" + response.statusText);
      }
    });
  };
  _proto.toString = function toString() {
    var s = "";
    switch (this.type) {
      case ResourceType.STATIC:
        s += "\nStatic resource (";
        s += this.creativeType;
        s += "): ";
        s += this.stringData;
        break;
      case ResourceType.HTML:
        s += "\nHTML resource (";
        s += this.encoded ? "encoded): " : "unencoded): ";
        s += (0, _StringUtils.formatHtml)(this.stringData);
        break;
      case ResourceType.IFRAME:
        s += "\niFrame resource: ";
        s += this.stringData;
        break;
    }
    return s;
  };
  return Resource;
}(_XmlValidation2.XmlValidation);
exports.Resource = Resource;